import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import {
  fetchMissingEntities,
  fetchMissingEntitiesTraffic,
} from './monitoring';

export const getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace =
  createAsyncThunk(
    'deviceHistories/getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace',
    async (payload, { dispatch }) => {
      const { workspaceId, take, skip, ...variables } = payload || {};

      const deviceHistories =
        await api.deviceHistory.getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace(
          {
            ...variables,
            workspaceId,
            take,
            skip,
            sort: {
              receivedAt: 'desc',
            },
          }
        );

      const deviceHistoriesData =
        deviceHistories.data
          .getDeviceHistoriesByWorkspaceAndWorkspaceToWorkspace;
      await dispatch(
        fetchMissingEntitiesTraffic({
          deviceHistories: deviceHistoriesData,
        })
      );

      return deviceHistories.data
        .getDeviceHistoriesByWorkspaceAndWorkspaceToWorkspace;
    }
  );

export const getDeviceHistoryByDeviceId = createAsyncThunk(
  'deviceHistories/getDeviceHistoryByDeviceId',
  async (payload, { dispatch }) => {
    const { id, take, skip } = payload || {};

    const deviceHistories = await api.deviceHistory.getDeviceHistoryByDeviceId({
      id,
      take,
      skip,
      sort: {
        receivedAt: 'desc',
      },
    });

    console.log('HERE');

    await dispatch(
      fetchMissingEntities({
        deviceHistories: deviceHistories.data.getDeviceHistoryByDeviceId,
      })
    );

    return deviceHistories.data.getDeviceHistoryByDeviceId;
  }
);
